var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4867 2.00568L8.86523 6.18082L9.90478 3.71754L14.4867 2.00568Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50924 2.00568L7.08551 6.22037L6.09681 3.71754L1.50924 2.00568ZM12.464 11.6836L10.9669 13.9774L14.1703 14.8588L15.0912 11.7345L12.464 11.6836ZM0.916016 11.7345L1.83127 14.8588L5.03466 13.9774L3.53748 11.6836L0.916016 11.7345Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85359 7.8079L3.96094 9.15818L7.14173 9.29942L7.02873 5.88134L4.85359 7.8079ZM11.1417 7.8079L8.93834 5.8418L8.86489 9.29942L12.04 9.15818L11.1417 7.8079ZM5.03438 13.9774L6.94399 13.0452L5.29427 11.7571L5.03438 13.9774ZM9.05133 13.0452L10.9666 13.9774L10.7011 11.7571L9.05133 13.0452Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9674 13.9774L9.0521 13.0452L9.20465 14.2938L9.1877 14.8192L10.9674 13.9774ZM5.03516 13.9774L6.81482 14.8192L6.80352 14.2938L6.94476 13.0452L5.03516 13.9774Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84322 10.9322L5.25 10.4633L6.37429 9.94916L6.84322 10.9322ZM9.15395 10.9322L9.62288 9.94916L10.7528 10.4633L9.15395 10.9322Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03428 13.9774L5.30547 11.6836L3.53711 11.7345L5.03428 13.9774ZM10.6953 11.6836L10.9665 13.9774L12.4637 11.7345L10.6953 11.6836ZM12.0399 9.15819L8.86479 9.29943L9.15858 10.9322L9.6275 9.94915L10.7574 10.4633L12.0399 9.15819ZM5.24897 10.4633L6.37892 9.94915L6.84219 10.9322L7.14163 9.29943L3.96084 9.15819L5.24897 10.4633Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.96094 9.1582L5.29427 11.7571L5.24907 10.4633L3.96094 9.1582ZM10.7575 10.4633L10.7011 11.7571L12.04 9.1582L10.7575 10.4633ZM7.14173 9.29945L6.84229 10.9322L7.21517 12.8588L7.29992 10.322L7.14173 9.29945ZM8.86489 9.29945L8.71235 10.3164L8.78015 12.8588L9.15868 10.9322L8.86489 9.29945Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1596 10.9322L8.78107 12.8587L9.05226 13.0452L10.702 11.757L10.7585 10.4633L9.1596 10.9322ZM5.25 10.4633L5.2952 11.757L6.94492 13.0452L7.2161 12.8587L6.84322 10.9322L5.25 10.4633Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1877 14.8192L9.20465 14.2938L9.06341 14.1695H6.93346L6.80352 14.2938L6.81482 14.8192L5.03516 13.9774L5.65663 14.4859L6.91651 15.3616H9.08035L10.3459 14.4859L10.9674 13.9774L9.1877 14.8192Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05132 13.0452L8.78014 12.8588H7.21516L6.94398 13.0452L6.80273 14.2938L6.93268 14.1695H9.06262L9.20386 14.2938L9.05132 13.0452Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7234 6.45197L15.2037 4.14689L14.4861 2.00565L9.05111 6.03954L11.1415 7.80791L14.0963 8.67231L14.7517 7.9096L14.4692 7.70621L14.9212 7.29378L14.5709 7.02259L15.0229 6.67796L14.7234 6.45197ZM0.796875 4.14689L1.2771 6.45197L0.972016 6.67796L1.42399 7.02259L1.07936 7.29378L1.53134 7.70621L1.24885 7.9096L1.89857 8.67231L4.85337 7.80791L6.94377 6.03954L1.50874 2.00565L0.796875 4.14689Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0968 8.67233L11.142 7.80792L12.0403 9.15821L10.7013 11.7571L12.464 11.7345H15.0912L14.0968 8.67233ZM4.85387 7.80792L1.89907 8.67233L0.916016 11.7345H3.53748L5.29455 11.7571L3.96121 9.15821L4.85387 7.80792ZM8.86517 9.29945L9.05161 6.03956L9.91037 3.71753H6.09681L6.94426 6.03956L7.142 9.29945L7.2098 10.3277L7.21545 12.8588H8.78042L8.79172 10.3277L8.86517 9.29945Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0564972,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.2d7d9759186743df4098849fbfa07c9e.svg";
export { ForwardRef as ReactComponent };